var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buy-one-get-one-container"},[_c('div',{staticClass:"buy-one-get-one-content"},[_vm._v("\n    "+_vm._s(_vm.$t('buy'))+" "+_vm._s(this.fromQty)+" "+_vm._s(_vm.$t('get'))+" "+_vm._s(this.relatedQty)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60e1995b","hasScoped":false,"transformToRequire":{"vue-h-zoom":["image","image-full"]},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buy-one-get-one/buy-one-get-one.vue
// module id = null
// module chunks = 